import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-add-event-confirmation-dialog',
    templateUrl: './add-event-confirmation-dialog.component.html',
    styleUrls: ['./add-event-confirmation-dialog.component.scss'],
    standalone: false
})
export class AddEventConfirmationDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<AddEventConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  cancel() {
    this.dialogRef.close();
  }
}